import React from 'react';

// A crash on one page shows a calm message with a way out, never a blank page. It also logs the error so it can be found.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('RideBuraq page error:', error, info && info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" data-testid="error-boundary" style={{ minHeight: '100vh', background: '#000', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ maxWidth: 420, textAlign: 'center' }}>
          <p style={{ fontSize: 12, letterSpacing: '0.3em', textTransform: 'uppercase', color: '#D1D5DB', margin: 0 }}>RideBuraq</p>
          <h1 style={{ fontSize: 26, fontWeight: 600, margin: '14px 0 10px' }}>Something went wrong on this page</h1>
          <p style={{ fontSize: 16, lineHeight: 1.5, color: '#D1D5DB', margin: '0 0 24px' }}>
            Your booking and payment are safe. Please reload the page, or go back to your dashboard. If it keeps happening, call us at +1 (929) 560-6305.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button type="button" data-testid="error-reload" onClick={() => window.location.reload()} style={{ minHeight: 48, padding: '0 24px', borderRadius: 999, border: 0, background: '#F97316', color: '#0a0a0a', fontWeight: 700, fontSize: 16, cursor: 'pointer' }}>Reload</button>
            <button type="button" data-testid="error-home" onClick={() => { window.location.assign('/dashboard'); }} style={{ minHeight: 48, padding: '0 24px', borderRadius: 999, border: '1px solid rgba(255,255,255,0.3)', background: 'transparent', color: '#fff', fontSize: 16, cursor: 'pointer' }}>Dashboard</button>
          </div>
        </div>
      </div>
    );
  }
}
